import script from "./AtomTippyJS.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomTippyJS.vue?vue&type=script&lang=ts&setup=true"

import "./AtomTippyJS.vue?vue&type=style&index=0&id=d8c0ceea&lang=css"

const __exports__ = script;

export default __exports__